/* components/kitchen/menu/DishesSectioned.jsx — разделы меню с блюдами.
   Группирует блюда по разделам (SectionHeader + DishRow). DnD на desktop
   (drag-handle, drop-indicator) + кнопки ↑/↓ везде. Раздел — drop-target для append.
   ХЕНДОФФ → frontend/src/components/kitchen/menu/DishesSectioned.jsx. */

import React from 'react';
import { DishRow } from './DishRow.jsx';
import { SectionHeader } from './SectionHeader.jsx';
import { Icon } from '../../ui/Icon.jsx';

  const { useState } = React;

  function DishesSectioned({
    sections = [], dishes = [], mobile, targetFc,
    onSectionRename, onSectionMove, onSectionDelete,
    onDishMove, onChangeSection, onDeleteDish, onOpen,
    onReorder, onDropToSection, onAddDish,
  }) {
    const [draggingId, setDraggingId] = useState(null);
    const [overId, setOverId] = useState(null);

    const start = (id) => (e) => { setDraggingId(id); try { e.dataTransfer.effectAllowed = 'move'; e.dataTransfer.setData('text/plain', String(id)); } catch (_) {} };
    // Safari/Mac: без dropEffect='move' в dragover WebKit показывает «запрещено» и не шлёт drop
    const allowMove = (e) => { e.preventDefault(); try { e.dataTransfer.dropEffect = 'move'; } catch (_) {} };
    const over = (id) => (e) => { allowMove(e); if (id !== overId) setOverId(id); };
    // stopPropagation — иначе drop на строке всплывает до секции и dropToSection перекидывает блюдо в конец
    const drop = (id) => (e) => { e.preventDefault(); e.stopPropagation(); if (draggingId && draggingId !== id) onReorder && onReorder(draggingId, id); setDraggingId(null); setOverId(null); };
    const end = () => { setDraggingId(null); setOverId(null); };

    const secDrop = (sectionId) => (e) => { e.preventDefault(); if (draggingId) onDropToSection && onDropToSection(draggingId, sectionId); setDraggingId(null); setOverId(null); };

    const renderDishList = (items) => (
      <div className="menu-section__dishes">
        {items.map((dish, di) => (
          <DishRow key={dish.id} dish={dish} sections={sections} mobile={mobile}
            targetFc={targetFc}
            canUp={di > 0} canDown={di < items.length - 1}
            isOver={overId === dish.id && draggingId !== dish.id}
            drag={!mobile ? { draggable: true, dragging: draggingId === dish.id, onDragStart: start(dish.id), onDragOver: over(dish.id), onDrop: drop(dish.id), onDragEnd: end } : null}
            onOpen={onOpen} onDelete={onDeleteDish}
            onMove={onDishMove} onChangeSection={onChangeSection} />
        ))}
      </div>
    );

    const sectionIds = new Set(sections.map((s) => s.id));
    // Блюда без раздела (section_id == null) или со ссылкой на отсутствующий раздел — идут в
    // неявную группу «Без раздела» (бэк допускает MenuDish.section = NULL). Без неё блюда меню
    // без разделов были бы невидимы в редакторе.
    const unsectioned = dishes.filter((d) => !sectionIds.has(d.section_id));

    return (
      <div className="dishes-sectioned">
        {sections.map((sec, si) => {
          const items = dishes.filter((d) => d.section_id === sec.id);
          return (
            <section key={sec.id} className="menu-section"
              onDragOver={!mobile ? allowMove : undefined}
              onDrop={!mobile ? secDrop(sec.id) : undefined}>
              <SectionHeader section={sec} count={items.length}
                canUp={si > 0} canDown={si < sections.length - 1}
                onRename={(t) => onSectionRename(sec.id, t)} onMove={(dir) => onSectionMove(sec.id, dir)} onDelete={() => onSectionDelete(sec.id)} />

              {items.length === 0 ? (
                <p className="menu-section__empty t-body-sm text-mute">В разделе пока нет блюд. Добавьте блюдо из списка ТТК.</p>
              ) : renderDishList(items)}
              <button type="button" className="menu-section__add" onClick={() => onAddDish && onAddDish(sec.id)}>
                <Icon name="plus" size={15} /><span>Добавить блюдо</span>
              </button>
            </section>
          );
        })}

        {unsectioned.length > 0 && (
          <section className="menu-section menu-section--loose"
            onDragOver={!mobile ? allowMove : undefined}
            onDrop={!mobile ? secDrop(null) : undefined}>
            <div className="menu-section__head">
              <h3 className="menu-section__title t-body-sm text-dim">Без раздела</h3>
              <span className="menu-section__count num">{unsectioned.length}</span>
            </div>
            {renderDishList(unsectioned)}
          </section>
        )}
      </div>
    );
  }

export { DishesSectioned };
